import { ComboBox, FormControl } from '@airbus/components-react';
import { truncateLabel } from '../../utils/labels';
import { DropdownOption } from '../../types';

type BulkUpdateSingleSelectInputProps = {
  id: string;
  value: string | number | null;
  options: DropdownOption[];
  onChange: (value: string | number | null) => void;
  onBlur?: () => void;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
};

export default function BulkUpdateSingleSelectInput({
  id,
  value,
  options,
  onChange,
  onBlur,
  disabled = false,
  hasError = false,
  errorMessage,
}: BulkUpdateSingleSelectInputProps) {
  const selected = options.find((option) => String(option.value) === String(value)) ?? null;

  return (
    <FormControl
      id={id}
      disabled={disabled}
      error={hasError || Boolean(errorMessage)}
      helpText={errorMessage || undefined}
      errorText={errorMessage || undefined}
      className='input-small disabled-input'
    >
      <ComboBox
        name={id}
        size='small'
        disabled={disabled}
        options={options}
        value={selected}
        getOptionLabel={(option) => truncateLabel(option?.label)}
        getOptionValue={(option) => option?.value ?? ''}
        onChange={(option) => {
          if (!option || option === '') {
            onChange(null);
            return;
          }
          onChange(option.value ?? null);
        }}
        keepInputOnSelect
        allowVirtualization
        hideClear
        onBlur={onBlur}
      />
    </FormControl>
  );
}
